import type { CollectionListOptions, CollectionsQuery } from '#graphql-operations'
import type { GraphqlResponseError } from 'nuxt-graphql-middleware/dist/runtime/types'

export async function collections(options: CollectionListOptions) {
  const { data, errors } = await useGraphqlQuery('collections', { options }) as { data: CollectionsQuery, errors: GraphqlResponseError[] }

  if (errors?.length)
    console.error('GraphQL errors:', errors)

  return data.collections
}
